import {lazy} from '@aboutyou/lazy-imports';

export const SeoPages = lazy(
  () =>
    import('./SeoPages.eager').then(mod => ({
      default: mod.SeoPages,
    })),
  {
    aboveTheFold: true,
  },
);
